<template>
    <div style="padding:10px;">
        <p style="font-size:14px;color:#575b5e;margin-bottom:5px;">
        选择周期：</p>
        <table class="authorization-table" :class="[periodData.length > 3 ? 'many' : 'few']" border="0"
            cellspacing='0' cellpadding='0'>
            <colgroup>
                <col width='53px'>
                <col width='198px'>
                <col width='auto'>
            </colgroup>
            <thead>
                <tr>
                    <th rowspan="1">勾选</th>
                    <th rowspan="1">周期</th>
                    <th rowspan="1">单价</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in periodData"
                    :key='item._id' :class="{disabled: isDisable(item) || item.isChecked}" @click="choosePeriod(item,index)">
                    <td>
                        <div class="select"
                            :class="{active: item.cselect || item.isChecked,disabled: isDisable(item) || item.isChecked}">
                        </div>
                    </td>
                    <td class="data_box" :class="{disabled: isDisable(item) || item.isChecked}">
                        {{item.title}}
                    </td>
                        
                    <td colspan="1" style='border-bottom:1px solid #ebf1f5;color:#78363a;font-weight:bold;' class="purchaser">
                        +{{item.priceTxt}}
                    </td>
                </tr>
            </tbody>

        </table>
        <p style="font-size:14px;color:#575b5e;margin-bottom:5px;margin-top: 5px;">
            选择交易所：
        </p>
        <!-- <p class="hy_title" style="font-size:14px;color:#575b5e;margin-bottom:5px;margin-top: 5px;">
            <span :class="{active:hy_title == 0}">
                选择交易所
            </span>    
            <span :class="{active:hy_title == 1}">
                VIX模式
            </span>    
        </p> -->
        <table class="authorization-table" :class="[innerBourseData.length > 3 ? 'many' : 'few']" border="0"
            cellspacing='0' cellpadding='0'>
            <colgroup>
                <col width='53px'>
                <col width='198px'>
                <col width='auto'>
            </colgroup>
            <thead>
                <tr>
                    <th rowspan="1">勾选</th>
                    <th rowspan="1">交易所</th>
                    <th rowspan="1">合约</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in innerBourseData"
                    :key='item._id' :class="{disabled: isDisable(item) || item.isChecked}" @click="chooseBourse(item,index)">
                    <td>
                        <div class="select"
                            :class="{active: item.cselect || item.isChecked,disabled: isDisable(item) || item.isChecked}">
                        </div>
                    </td>
                    <td class="data_box" :class="{disabled: isDisable(item) || item.isChecked}">
                        {{item.ctitle}}
                    </td>
                    <td class="pop"
                        :class="{last: index >= innerBourseData.length - 2}"
                        style="border-bottom:1px solid #ebf1f5;" @click.stop="_=>{}">
                        <span v-html="item.productintro" v-content:[13]="item.productintro"></span>
                        <!-- <div class="pop_wraper" @click.stop='_=>{}' v-html="item.productintro"></div> -->
                    </td>
                </tr>
            </tbody>

        </table>
        <p class="more">更多境外交易所<span @click="showOuterBourse">{{openTxt}}</span></p>
        
        <table class="authorization-table" v-if="this.openTxt == '收起'" :class="[outerBourseData.length > 3 ? 'many' : 'few']" border="0"
            cellspacing='0' cellpadding='0'>
            <colgroup>
                <col width='53px'>
                <col width='198px'>
                <col width='auto'>
            </colgroup>
            <thead>
                <tr>
                    <th rowspan="1">勾选</th>
                    <th rowspan="1">交易所</th>
                    <th rowspan="1">合约</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in outerBourseData"
                    :key='item._id' :class="{disabled: isDisable(item) || item.isChecked}" @click="chooseBourse(item,index)">
                    <td>
                        <div class="select"
                            :class="{active: item.cselect || item.isChecked,disabled: isDisable(item) || item.isChecked}">
                        </div>
                    </td>
                    <td class="data_box" :class="{disabled: isDisable(item) || item.isChecked}">
                        {{item.ctitle}}
                    </td>
                    <td class="pop"
                        :class="{last: index >= outerBourseData.length - 2}"
                        style='border-bottom:1px solid #ebf1f5;' @click.stop="_=>{}">
                        <span v-html="item.productintro" v-content:[13]="item.productintro"></span>
                        <!-- <div class="pop_wraper" @click.stop='_=>{}' v-html="item.productintro"></div> -->
                    </td>
                </tr>
            </tbody>

        </table>
    </div>
</template>

<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'history-table',
        model: {
            prop: 'authPrice',
            event: 'change'
        },
        inject: ['globalTabType', 'fatherType','historyHandleOpen'],
        props: {
            authData: {
                type: Array,
                default: () => ([])
            },
            authPrice: {
                type: Number,
                default: 0
            },
        },
        data: () => ({
            map: new Map(),
            periodData: [],
            innerBourseData: [],
            outerBourseData: [],
            openTxt: '展开',
            hy_title: 0
        }),
        methods: {
            async clickPeriod(item, index, call) {
                if (item.isChecked) return //已默认勾选不操作
                if (item.cdisable) return //已禁用的不做任何操作
                if (item.creject) return //已禁用的不做任何操作
                for (let i = 0; i < this.periodData.length; i++) {
                    if (this.periodData[i]._id != item._id && this.periodData[i].cdisable && this.periodData[i].cselect) return //如果另外的周期项已经被选则并禁用那么不要做任何操作
                }
                item.cselect = !item.cselect
                this.periodData.forEach(v => { //互斥罗辑，被排斥的项置灰
                    if (v._id != item._id) {
                        v.creject = !v.creject
                    }
                })
                call && call()
                this.$nextTick(()=>{
                    this.$emit('change',this.totalPrice)
                })

            },
            async clickBourse(item, index, call) {
                if (item.isChecked) return //已默认勾选不操作
                if (item.cdisable) return //已禁用的不做任何操作
                if (item.creject) return //已禁用的不做任何操作
                
                item.cselect = !item.cselect
                call && call()
                this.$nextTick(()=>{
                    this.$emit('change',this.totalPrice)
                })

            },
            selectItemByMemory(item) { //根据外部组件浅拷贝的缓存数据，选中当前组件中的项
                let target = this.tableData.find(v => v.id == item.id)
                this.selectItem(target, resolve => {
                    resolve(item.cmajor)
                })
            },
            choosePeriod(item, index) {
                this.$emit('choose', this.clickPeriod, item, index)
            },
            chooseBourse(item, index) {
                this.$emit('choose', this.clickBourse, item, index)
            },
            clearData() {
                this.periodData = []
                this.innerBourseData = []
                this.outerBourseData = []
                this.map = new Map()
            },
            isDisable(item) {
                if (item.cdisable) {
                    return true
                } else if (item.creject) {
                    return true
                } else {
                    return false
                }
            },
            getSelect() { //用于向外暴露，AuthChoose中调用
                let selectPeriod = this.periodData.find(v=>v.cselect || v.isChecked)

                if (!selectPeriod) return []

                let selectBourse = [...this.innerBourseData.filter(v=>v.cselect || v.isChecked), ...this.outerBourseData.filter(v=>v.cselect || v.isChecked)]
                
                return selectBourse.map(v=> this.map.get(selectPeriod.type).get('items')[v.ctitle])
            },
            cancelAll() {
                this.periodData.forEach(v=>{
                    if (!v.cdisable && !v.creject) {
                        this.$set(v,'cselect',false)
                    }
                    this.$set(v,'creject',false)
                })
                this.innerBourseData.forEach(v=>{
                    if (!v.cdisable && !v.creject) {
                        this.$set(v,'cselect',false)
                    }
                    this.$set(v,'creject',false)
                })
                this.outerBourseData.forEach(v=>{
                    if (!v.cdisable && !v.creject) {
                        this.$set(v,'cselect',false)
                    }
                    this.$set(v,'creject',false)
                })
                this.$nextTick(() => {
                    this.$emit('change', this.totalPrice)
                })
            },
            init (data) {//此处是一座屎山
                let map = this.map
                data.forEach(v=> {
                    if (!map.get(v.grouptype)) {
                        map.set(v.grouptype, new Map())
                        map.get(v.grouptype).set('title', v.productName.split('_')[0])
                        map.get(v.grouptype).set('priceTxt', v.price + v.unit)
                        map.get(v.grouptype).set('price', v.price)
                        map.get(v.grouptype).set('isMutex', v.isMutex)
                        map.get(v.grouptype).set('isout', v.isout)
                        map.get(v.grouptype).set('cdisable', false)
                        map.get(v.grouptype).set('cselect', false)
                        map.get(v.grouptype).set('items', {})
                        map.get(v.grouptype).set('innerBourse', [])
                        map.get(v.grouptype).set('outerBourse', [])

                    }
                    let cdisable = map.get(v.grouptype).get('cdisable')
                    map.get(v.grouptype).set('cdisable',cdisable || v.cdisable)
                    map.get(v.grouptype).set('cselect',cdisable || v.cdisable)
                    map.get(v.grouptype).get('items')[v.productName.split('_')[1]] = v
                    map.get(v.grouptype).get(v.isout ?'outerBourse':'innerBourse').push({
                        ...v,
                        ctitle: v.productName.split('_')[1],
                        creject: false,
                        cdisable: v.cdisable,
                        cselect: false,
                        _id: wh.randomId()
                    })
                })
                this.periodData = Reflect.ownKeys(Object.fromEntries(map)).map(v=>{
                    return {
                        title: map.get(Number(v)).get('title'),
                        price: map.get(Number(v)).get('price'),
                        priceTxt: map.get(Number(v)).get('priceTxt'),
                        isMutex: map.get(Number(v)).get('isMutex'),
                        isout: map.get(Number(v)).get('isout'),
                        type: Number(v),
                        creject: map.get(Number(v)).get('cdisable'),
                        cdisable: false,
                        cselect:  map.get(Number(v)).get('cselect'),
                        _id: wh.randomId()
                    }
                }).sort((a,b)=>b.type - a.type)
                

                let bourse = Array.from(map).map(v=>v[1])[0]
                this.innerBourseData = bourse.get('innerBourse')
                this.outerBourseData = bourse.get('outerBourse')
            },
            showOuterBourse () {
                switch (this.openTxt) {
                    case '展开':
                        this.openTxt = '收起'
                        break
                    case '收起':
                        this.openTxt = '展开'
                        break
                }
                this.$nextTick(_=>{
                    if(this.openTxt == '收起') {
                        this.historyHandleOpen()
                    }
                })
            }
        },
        computed: {
            totalPrice() {
                var price = 0;
                let singlePrice = this.periodData.find(v=>v.cselect || v.isChecked)?.price || 0
                return singlePrice*this.bourseNum;
            },
            tabType() {
                return this.$store.state.globalTabType
            },
            bourseNum () {
                return this.innerBourseData.filter(v=>v.cselect || v.isChecked).length + this.outerBourseData.filter(v=>v.cselect || v.isChecked).length
            },
            isUnFinishSelect () {
                return (this.periodData.find(v=>v.cselect || v.isChecked) && 
                (this.innerBourseData.filter(v=>v.cselect || v.isChecked).length <= 0 && this.outerBourseData.filter(v=>v.cselect || v.isChecked).length <= 0)) ||
                (!this.periodData.find(v=>v.cselect || v.isChecked) && 
                (this.innerBourseData.filter(v=>v.cselect || v.isChecked).length > 0 || this.outerBourseData.filter(v=>v.cselect || v.isChecked).length > 0))
            },
            isLackOfPeriod () {
                return (!this.periodData.find(v=>v.cselect || v.isChecked) && 
                (this.innerBourseData.filter(v=>v.cselect || v.isChecked).length > 0 || this.outerBourseData.filter(v=>v.cselect || v.isChecked).length > 0))
            }
        },
        watch: {
            authData: {
                handler(val) {
                    if (val && val.length > 0) {
                        this.clearData()
                        this.init(val)
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    .hy_title span.active {
        border-bottom:1px solid rgb(188, 220, 245);
        background-color: rgb(188, 220, 245);
    }
    .hy_title span {
        border-bottom:1px solid rgb(188, 220, 245);
        padding: 5px;
    }
    .more {
        font-size: 13px;
        color: #8d6d3c;
        padding-left: 54px;
        margin: 8px 0;
    }
    .more span {
        text-decoration: underline;
        color: #0660ac;
        cursor: pointer;
        margin-left: 5px;

    }
    .authorization-table {
        border-collapse: collapse;
        text-align: left;
        width: 100%;
        font-size: 12px;
        color: #525252;
        background: white;
        table-layout: fixed;
    }

    .authorization-table tr {
        cursor: pointer;
    }

    .authorization-table tr.disabled {
        cursor: default;
    }

    .authorization-table td.data_box {
        border-bottom: 1px solid #ebf1f5;
        position: relative;
        padding-left: 0;
    }

    .authorization-table td.data_box.disabled {
        color: #b3b3b3;
    }

    .authorization-table td:nth-child(2) {
        text-align: left;
    }

    .authorization-table td i.tips {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url(../assets/image/zhuyi.png) no-repeat center;
        position: relative;
        margin-left: 3px;
    }

    .authorization-table td i.tips .tips_content {
        display: none;
        position: absolute;
        top: 15px;
        left: -116px;
        font-style: normal;
        width: 200px;
        text-align: left;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        z-index: 10;
        padding: 10px 1px 10px 10px;
        color: #525252;
        line-height: normal;
        font-weight: normal;
    }

    .authorization-table td i.tips:hover .tips_content {
        display: block;
    }

    .authorization-table th {
        background: #f7e2e1;
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 14px;
        height: 23px;
        padding: 0 2px;
        text-align: center;
        border: 1px solid rgb(211, 215, 218);
        border-bottom: 0;
        border-top: 0;
        box-sizing: border-box;
    }

    .authorization-table.yellow th {
        background: #ffebcc;
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 13px;
        height: 24px;
        padding: 5px 2px;
        text-align: center;
        border: 1px solid #f1cf9b;
        border-bottom: 0;
        border-top: 0;
    }

    .authorization-table.blue th {
        background: #bcdcf5;
        color: rgb(87, 91, 94);
        font-weight: normal;
        font-size: 13px;
        height: 24px;
        padding: 5px 2px;
        text-align: center;
        border: 1px solid #fff;
        border-bottom: 0;
        border-top: 0;
    }

    .authorization-table th.no_padding {
        padding: 0 2px;
    }

    .authorization-table h5,
    .authorization-list table p {
        margin: 0;
        padding: 0;
    }

    .authorization-table th h5 {
        font-size: 13px;
        font-weight: normal;
    }

    .authorization-table th p {
        font-size: 12px;
        font-weight: normal;
    }

    .authorization-table td {
        text-align: center;
        border: 0px solid #cccccc;
        border-right: 1px solid rgb(235, 241, 245);
        height: 27px;
        padding: 0 10px;
        font-size: 14px;
    }

    .authorization-table tr td:last-child {
        border-right: 0;
    }

    .authorization-table tr td:first-child {
        border-bottom: 1px solid rgb(235, 241, 245);
        border-right: 0;
    }

    .authorization-table td.purchaser {
        text-align: left;
        padding: 0 10px;
        font-size: 13px;
    }

    .authorization-table td.charge {
        text-align: left;
        padding: 0 0;

    }

    .authorization-table td .price {
        padding-left: 15px;
    }

    .authorization-table .internal_tr td .price {
        padding-left: 0;
    }

    .authorization-table td .people,
    .authorization-table td .price {
        border-bottom: 1px solid rgb(235, 241, 245);
        display: block;
        line-height: 24px;
    }

    .authorization-table td .people:last-child,
    .authorization-table td .price:last-child {
        border-bottom: 0;
    }

    /* .authorization-table tr:hover {
        background-color: rgb(233, 241, 253);
    } */

    .authorization-table td .price.major_active {
        font-weight: 600;
        color: #78363A;
    }

    .authorization-table td.pop {
        color: #848484;
        position: relative;
    }

    .authorization-table td .pop_wraper {
        display: none;
        width: 427px !important;
        text-align: left !important;
        padding: 15px 17px 15px 20px;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        position: absolute;
        left: -285px;
        z-index: 10;
        color: #525252;
        /* display: none; */
        top: 29px;
    }

    .authorization-table td.pop:hover .pop_wraper {
        display: block;
    }

    .authorization-table td .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: -8px;
        border-bottom: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
    }

    .authorization-table td .select {
        width: 15px;
        height: 15px;
        display: inline-block;
        border: 1px solid rgb(175, 175, 175);
        box-sizing: border-box;
        border-radius: 100%;
        position: relative;
        top: 2px;
    }

    .authorization-table td .select.active {
        background: url(../assets/image/dui-bai.png) no-repeat center rgb(243, 152, 0);
        border: 1px solid rgb(243, 152, 0);
    }

    .authorization-table td .select.disabled {
        background: #e7ebee;
        border: 1px solid #d6d9dc;
    }

    .authorization-table td .select.active.disabled {
        background: url(../assets/image/dui-bai.png) no-repeat center #ced6dc;
        border: 1px solid rgb(175, 175, 175);
    }

    .authorization-table tr td.pop.last .pop_wraper {
        bottom: 29px;
        top: initial;
    }

    .authorization-table.few tbody tr:first-child td .pop_wraper {
        bottom: initial;
        top: 29px;
    }

    .authorization-table tr td.pop.last .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: initial;
        bottom: -8px;
        border-bottom: 0;
        border-top: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
    }

    .authorization-table.few tbody tr:first-child td .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        bottom: initial;
        top: -8px;
        border-bottom: 8px solid rgb(171, 161, 206);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: none;
    }
    .authorization-table tr td.pop span{
        width: 219px;
        overflow: hidden;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .authorization-table tr td.pop>>>* {
        font-size: 13px !important;
        font-family: 'microsoft yahei' !important;
    }
</style>
